import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  ContentSection,
  ContentSectionHeading,
  ContentSectionWrapper,
  Image,
} from 'shared/SectionControl/NewSectionModal/components/ModalContent/pages/style'

import MapSectionImage from '../../assets/MapSection/map-section.png'

export const MapPage = () => {
  const { t } = useTranslation()

  return (
    <ContentSectionWrapper>
      <ContentSectionHeading>{t('Map section')}</ContentSectionHeading>
      <ContentSection>
        <Image alt="" src={MapSectionImage} />
      </ContentSection>
    </ContentSectionWrapper>
  )
}
